module.exports = __webpack_public_path__ + "img/swell.a598fc11.jpg";